<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-epigraph element-without-heading" id="intro-to-combat-experience">
<div class="text" id="intro-to-combat-experience-text">
<p class="first first-in-chapter first-full-width"><i>Richard Matheson is a seminal, brilliant, and highly influential writer who deserves to be a household name along with Ray Bradbury or Isaac Asimov, although he isn’t as well known. You are familiar with his work, though, as the writer of the stories behind countless incredible films, such as I Am Legend, Somewhere in Time, Duel, The Incredible Shrinking Man, What Dreams May Come, A Stir of Echoes, Real Steel, The Legend of Hell House, and many others. When a specialty press asked if I would write a story for a Matheson tribute anthology of stories about the human effects of war, as a companion to Matheson’s novel Beardless Warriors, I couldn’t say no.</i></p>
<p class="subsq"><i>I had wanted to write this story for more than a year, but never had the impetus to do so. The idea kept nagging at me, and it seemed to fit perfectly with the anthology. After I turned in the story, I received this letter from Matheson’s son, Richard Christian Matheson—an extremely talented novelist and screenwriter in his own right—saying he loved the story, “Its dread about war's futility (even far tomorrows, sadly, immunizing none) resonates with quiet melancholy and it absolutely belongs in the anthology.” I knew I had hit the mark.</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introtocombatexperience.vue?4bc2c901